export enum TicketActionType {
    LOAD_TICKETS = 'LOAD_TICKETS',
    RESET_UNREAD = 'RESET_UNREAD',
    UPDATE_TICKET = 'UPDATE_TICKET',
    UPDATE_TICKET_UNREAD_MESSAGES = 'UPDATE_TICKET_UNREAD_MESSAGES',
    UPDATE_TICKET_CONTACT = 'UPDATE_TICKET_CONTACT',
    DELETE_TICKET = 'DELETE_TICKET',
    RESET = 'RESET',
}
